import {useZero} from '@/shared/integrations/zero/use-zero'
import {useEffect, useRef} from 'react'
import * as z from 'zod'

// Logs a "Patient accessed" entry once per opened patient record, not once per component using useGetPatient.
export function useRecordPatientView(patientId: string | undefined) {
  const zero = useZero()
  const recordedId = useRef<string | undefined>(undefined)

  useEffect(() => {
    const parsed = z.uuid().safeParse(patientId)
    if (!parsed.success || parsed.data === recordedId.current) return

    zero.attemptMutation(zero.mutators.patients.recordPatientView(parsed.data))
    recordedId.current = parsed.data
  }, [patientId, zero])
}
